import { AudioPresets, VideoPresets, type RoomOptions } from 'livekit-client';

/**
 * Единые настройки LiveKit-комнаты для admin (STAGE / breakout-доска
 * модератора). Зеркалит платформенный CALL_ROOM_OPTIONS
 * (apps/platform/src/features/calls/lib/room-options.ts) — admin
 * отдельный пакет, общего workspace-модуля для фронта нет.
 *
 * Цель — стабильная работа на слабом/нестабильном интернете без потери
 * качества у тех, у кого канал нормальный:
 *
 * - simulcast: камера публикует три слоя (h720 основной + h360 + h180).
 *   SFU (LiveKit ничего не перекодирует) отдаёт каждому получателю тот
 *   слой, который тянет именно его канал.
 * - dynacast: неиспользуемые слои не кодируются — меньше CPU/аплинка.
 * - adaptiveStream + pauseVideoInBackground: подписка под размер тайла,
 *   видео в фоновой вкладке на паузе.
 * - degradationPreference 'maintain-framerate': при нехватке полосы/CPU
 *   жертвуем резкостью, а не FPS.
 * - videoCodec 'vp8': SFU разрешает только h264/vp8/opus
 *   (docker/livekit/livekit.yaml).
 *
 * АУДИО (зеркало платформенного CALL_ROOM_OPTIONS):
 * - channelCount 1 (моно) + audioPreset 'musicHighQuality' (96 kbps).
 * - autoGainControl/echoCancellation/noiseSuppression ВЫКЛ — «сырой»
 *   необработанный звук (AGC сбрасывал громкость при громком голосе).
 *   ⚠️ без AEC возможно эхо без наушников — осознанный компромисс.
 * - red ВКЛ (устойчивость к потерям), dtx (тишина не шлётся).
 */
export const CALL_ROOM_OPTIONS: RoomOptions = {
  dynacast: true,
  adaptiveStream: {
    pauseVideoInBackground: true,
  },
  videoCaptureDefaults: {
    resolution: VideoPresets.h720.resolution,
    facingMode: 'user',
  },
  audioCaptureDefaults: {
    channelCount: 1,
    autoGainControl: false,
    echoCancellation: false,
    noiseSuppression: false,
  },
  publishDefaults: {
    simulcast: true,
    videoSimulcastLayers: [VideoPresets.h180, VideoPresets.h360],
    videoCodec: 'vp8',
    degradationPreference: 'maintain-framerate',
    audioPreset: AudioPresets.musicHighQuality,
    dtx: true,
    red: true,
  },
};
